import { z } from 'zod';

import { formatDate } from 'Utilities/formatters';

import { StateSlugSchema } from '../helpers/vehicle.schema';

import {
	BidSchema,
	MinimumBidSchema,
	SellerWillAcceptPriceSchema,
	SoldDateSchema,
	UserBidSchema,
} from './bidding.schema';

export const RealtimeBiddingDataSchema = z
	.object({
		acceptedBid: BidSchema.pick({ value: true }).partial(),
		highestBid: BidSchema.pick({ value: true }).partial().optional(),
		minimumBid: MinimumBidSchema.optional(),
		ownBids: UserBidSchema,
		sellerWillAcceptPrice: SellerWillAcceptPriceSchema.nullable(),
		soldDate: SoldDateSchema,
		stateSlug: StateSlugSchema,
	})
	.transform((data) => ({
		...data,
		// accepted bid and highest bid can sometimes be an empty object
		acceptedBid: data.acceptedBid.value ? { value: data.acceptedBid.value } : null,
		highestBid: data.highestBid?.value ? { value: data.highestBid.value } : null,
		soldDate: data.soldDate ? formatDate(data.soldDate) : null,
	}));

export type RealtimeBiddingData = z.infer<typeof RealtimeBiddingDataSchema>;
